/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActiveUserDto,
    ActiveUserDtoFromJSON,
    ActiveUserDtoFromJSONTyped,
    ActiveUserDtoToJSON,
} from './ActiveUserDto';

/**
 * 
 * @export
 * @interface PaginatedActiveUserDto
 */
export interface PaginatedActiveUserDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedActiveUserDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedActiveUserDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedActiveUserDto
     */
    offset: number;
    /**
     * 
     * @type {Array<ActiveUserDto>}
     * @memberof PaginatedActiveUserDto
     */
    items: Array<ActiveUserDto>;
}

export function PaginatedActiveUserDtoFromJSON(json: any): PaginatedActiveUserDto {
    return PaginatedActiveUserDtoFromJSONTyped(json, false);
}

export function PaginatedActiveUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedActiveUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(ActiveUserDtoFromJSON)),
    };
}

export function PaginatedActiveUserDtoToJSON(value?: PaginatedActiveUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(ActiveUserDtoToJSON)),
    };
}

